var _excluded = ["gutterSpace", "itemWidthSpace", "isFullWidthOnLarge", "justifyContent", "topSpace", "bottomSpace", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from "react";
import styled, { css } from "styled-components";
import PushSideStyles from "../../../helpers/PushSideStyles";
import PushStyles from "../../../helpers/PushStyles";
import { pageGutterSpace } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var gutterStyles = function gutterStyles(gutterSpace) {
  if (typeof gutterSpace === "number") {
    return css(["> *{margin-right:", ";}"], space(gutterSpace));
  }
  return css(["> *{", "}"], PushSideStyles("right", gutterSpace, true, "space", "margin"));
};
var StyledHorizontalScrollItemsOrg = styled.div.withConfig({
  componentId: "sc-1a7gp50-0"
})(function (_ref) {
  var $gutterSpace = _ref.$gutterSpace,
    $itemWidthSpace = _ref.$itemWidthSpace,
    $isFullWidthOnLarge = _ref.$isFullWidthOnLarge,
    $justifyContent = _ref.$justifyContent,
    $topSpace = _ref.$topSpace,
    $bottomSpace = _ref.$bottomSpace;
  return css(["", ";display:flex;margin:0;overflow-x:auto;", "{margin:0 ", ";&::before,&::after{content:\"\";flex-shrink:0;width:", ";}}> *{flex-shrink:0;&:last-child{margin-right:0;}", " ", "}", " ", " ", ";"], gutterStyles($gutterSpace), breakpoint("small", "large"), space(-1 * pageGutterSpace), space(pageGutterSpace), !!$itemWidthSpace && typeof $itemWidthSpace === "number" && css(["width:", ";"], space($itemWidthSpace)), !!$itemWidthSpace && _typeof($itemWidthSpace) === "object" && css(["width:", ";", "{width:", ";}", "{width:", ";}"], space($itemWidthSpace.small), breakpoint("medium"), space($itemWidthSpace.medium), breakpoint("large"), space($itemWidthSpace.large)), $isFullWidthOnLarge && css(["", "{width:100%;}"], breakpoint("large")), $justifyContent && css(["justify-content:", ";"], $justifyContent), PushStyles({
    top: $topSpace,
    bottom: $bottomSpace
  }, true, "space", "padding"));
});
function HorizontalScrollItemsOrg(_ref2) {
  var gutterSpace = _ref2.gutterSpace,
    itemWidthSpace = _ref2.itemWidthSpace,
    isFullWidthOnLarge = _ref2.isFullWidthOnLarge,
    justifyContent = _ref2.justifyContent,
    topSpace = _ref2.topSpace,
    bottomSpace = _ref2.bottomSpace,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledHorizontalScrollItemsOrg, _extends({
    $gutterSpace: gutterSpace,
    $itemWidthSpace: itemWidthSpace,
    $isFullWidthOnLarge: isFullWidthOnLarge,
    $justifyContent: justifyContent,
    $topSpace: topSpace,
    $bottomSpace: bottomSpace
  }, restProps), children);
}
export default HorizontalScrollItemsOrg;